module.exports = __webpack_public_path__ + "static/media/footer-ad.641fd6c6.jpg";